<template>
  <v-row v-if="shouldShowLearnMore">
    <v-col cols="12">
      <!-- 360 Tour URL Field -->
      <v-text-field
        v-model="tourUrl"
        label="360 Tour URL"
        placeholder="Optional"
        variant="outlined"
        dense
      ></v-text-field>

      <!-- Learn More Link -->
      <p class="learn-more">
        <a href="/360-tour-providers" class="link">Learn More</a> about our accepted 360 tour providers.
      </p>
    </v-col>
  </v-row>
</template>

<script setup>
// Keep existing script code unchanged
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { isCategoryType } from "@/utils/categorySubCategorySlugUtils";

// Vuex store and route
const store = useStore();
const route = useRoute();

// Reactive data for the 360 Tour URL
const tourUrl = ref("");

// Dynamically determine the subcategoryKey
const subcategoryKey = computed(() => {
  const categorySlug = store.getters["NewCategory/selectedCategory"]?.slug || route.params.categorySlug || null;
  const subcategoryId = store.getters["NewCategory/selectedSubCategory"]?.id || route.params.subcategoryId || null;

  // Log the categorySlug and subcategoryId for debugging
  console.log("LearnMore360 - Category Slug:", categorySlug);
  console.log("LearnMore360 - Subcategory ID:", subcategoryId);
  
  // Return consistent format: category-subcategoryId or just category
  return subcategoryId ? `${categorySlug}-${subcategoryId}` : categorySlug;
});

// Use the utility function for clean logic
const shouldShowLearnMore = computed(() => {
  const key = subcategoryKey.value;
  console.log("LearnMore360 - Checking key:", key);
  
  // Check for property-for-sale category
  const isProperty = isCategoryType(key, 'property-for-sale');
  
  // Check for motors/cars category or subcategory
  const isCar = key === 'motors' || 
                key?.includes('cars') ||
                (key?.includes('motors') && subcategoryKey.value?.includes('1'));
                
  console.log("LearnMore360 - Should show:", isProperty || isCar);
  
  // Show for both property-for-sale and cars
  return isProperty || isCar;
});
</script>

<style scoped>
.learn-more {
  font-size: 0.875rem;
  margin-top: 8px;
  color: #6c757d;
}

.link {
  color: #3a88ef;
  text-decoration: none;
  font-weight: 700;
}

.link:hover {
  text-decoration: underline;
}

/* Match the form styling from CarSignUpForm */
:deep(.v-text-field .v-input__slot) {
  min-height: 44px;
  background-color: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.23) !important;
  transition: border-color 0.2s ease;
}

:deep(.v-text-field--outlined fieldset) {
  border-color: transparent !important;
}

:deep(.v-text-field .v-input__slot:hover) {
  border-color: rgba(0, 0, 0, 0.5) !important;
}

:deep(.v-text-field--is-focused .v-input__slot) {
  border-color: #b30000 !important;
  box-shadow: 0 0 0 1px #b30000;
}

:deep(.v-label) {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 500;
}

:deep(.v-label--active) {
  color: #b30000 !important;
}
</style>